import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";

const PRODUCT_STRUCT_URL='/user/product/'
const PRODUCT_LIST='/user/products/'

@Injectable({   providedIn: 'root'})
export class NavUtils {

    
    private router = inject(Router);

    async goHome(){
        // this.router.navigateByUrl('/user/products', { skipLocationChange: false, replaceUrl: true }).then(() => {
        //     // manually reload the page after navigating to root
        //     location.reload();
        //   });
        await this.router.navigate(['/user/products']); //if not specific, 404 pages will get stuck. Don't change back to '/'
        // await this.router.navigateByUrl('/', { skipLocationChange: false });
        // window.location.href = '/';
        // this.router.navigateByUrl('/', { replaceUrl: true });
    }
    
    selectAndNavigateToProduct(productId:string){
        this.router.navigate([PRODUCT_STRUCT_URL+productId]);
    }

}